import { BorderRadiusCorners, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  reason: string
}

const ReasonBlock = ({ reason }: Props) => {
  const swap_request_reason = i18n.t('shift_management.swap_shifts.approval_requests.inbox.reason')
  const borderRadius: BorderRadiusCorners = {
    all: 'abs008',
  }

  return (
    <>
      <Box
        flexDirection="column"
        gap="s12"
        alignSelf="flexStart"
        borderRadius={borderRadius}
        background="grey200"
        padding="s16"
        width="full"
      >
        <Text size="300" weight="semibold" color="grey1000">
          {swap_request_reason}
        </Text>
        <Text size="300" weight="normal" color="grey1000">
          {reason}
        </Text>
      </Box>
    </>
  )
}

export default ReasonBlock
